import type { BlockComponentProps } from 'client-react-block-renderer';
import React, { Component } from 'react';
import t from 'rcm-i18n';
import getAppState from 'app-state';

interface State {
  signupType: string;
  selectedRank: string;
  signupFullUrl: string;
  currentUserAppState: CurrentUserAppState | null;
}

type Props = BlockComponentProps<Data, Config>;

interface Config {
  accountTypeOptions: string;
}

interface Data {}

interface CurrentUserAppState {
  /**
   * @todo This could be moved to shared location later
   * @deprecated
   * It doesn't look like there is any explicit need for a dedicated `userFound`
   * flag. Everything we're doing with it can be inferred based on the existence
   * of a `profile` and/or `userId`.
   */
  userFound: boolean;
  userId?: string;
  profile?: {
    status: string;
    rank: string;
  };
}

const accountTypeOptions = [
  {
    value: 'customer',
    label: t('Customer'),
    baseUrl: '/secure/checkout/v1#/checkout/customer',
    selectableRank: false,
  },
  {
    value: 'preferred-customer',
    label: t('Preferred Customer'),
    baseUrl: '/secure/checkout/v1#/checkout/preferred-customer',
    selectableRank: false,
  },
  {
    value: 'distributor',
    label: t('Distributor'),
    baseUrl: '/secure/checkout/v1#/checkout/distributor',
    selectableRank: true,
  },
];

export default class SignSomeoneUpToolBlockComponent extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.handleSignupTypeChange = this.handleSignupTypeChange.bind(this);
    this.handleSelectedRankChange = this.handleSelectedRankChange.bind(this);
    this.state = {
      signupType: 'distributor',
      selectedRank: '1',
      signupFullUrl: '',
      currentUserAppState: null,
    };
  }

  public componentDidMount() {
    this.setState({ currentUserAppState: getAppState('currentUser') });
  }

  protected getSignupUrl() {
    const signupTypeDetails = accountTypeOptions.find((option) => option.value === this.state.signupType);
    let signupFullUrl = '';
    if (signupTypeDetails) {
      signupFullUrl =
        'https://' +
        window.location.hostname +
        '/sponsor-signup/' +
        this.state.currentUserAppState.userId +
        '/' +
        this.state.signupType +
        (signupTypeDetails.selectableRank ? '?rank=' + this.state.selectedRank : '');
    }
    return signupFullUrl;
  }

  protected handleSignupTypeChange(event) {
    this.setState({ signupType: event.target.value });
  }

  protected handleSelectedRankChange(event) {
    this.setState({ selectedRank: event.target.value });
  }

  public render() {
    const selectedRankOptions = [
      { value: '1', label: '20' + '% ' }, // @TODO make data driven per market
      { value: '2', label: '25' + '% ' },
      { value: '3', label: '30' + '% ' },
      { value: '4', label: '35' + '% ' },
    ];
    const currentUserAppState = this.state.currentUserAppState;
    if (currentUserAppState === null) {
      return <div></div>; // Show blank page while loading.
    }
    if (!currentUserAppState.userFound || !['D', 'E'].includes(currentUserAppState.profile.status)) {
      return (
        <>
          <div className="alert alert-warning">{t('You must be logged in as a distributor to use this tool.')}</div>
          <a className="btn btn-primary" href={'/login?redirect=' + encodeURIComponent(window.location.pathname)}>
            {t('login')}
          </a>
        </>
      );
    }
    const signupUrl = this.getSignupUrl();
    const accountTypeOptionsToShow = JSON.parse(this.props.config.accountTypeOptions);
    const filteredAccountTypeOptions = accountTypeOptions.filter((option) =>
      accountTypeOptionsToShow.includes(option.value)
    );
    return (
      <div>
        <div className="rcmOnlineApplication RcmForm ng-scope">
          <div data-ng-hide="submissionComplete">
            <div className="ng-isolate-scope">
              <h1>{t('Sign Someone Up')}</h1>
              <p></p>{' '}
            </div>
            <form action="/" method="post" className="ng-valid ng-valid-email ng-dirty ng-valid-parse">
              <div className="container">
                <div className="row applicationType">
                  <div className="col-sm-9">
                    <h3>{t('New account type')}</h3>
                    <div>
                      {filteredAccountTypeOptions.map((option, index) => (
                        <div className="radio" key={index}>
                          <label htmlFor={'signupType' + option.value}>
                            <input
                              id={'signupType' + option.value}
                              type="radio"
                              name="signupType"
                              value={option.value}
                              checked={this.state.signupType === option.value}
                              onChange={this.handleSignupTypeChange}
                            />
                            <span>{t(option.label)}</span>
                          </label>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                {this.state.signupType === 'distributor' && (
                  <>
                    <h3>{t('Starting profit level')}</h3>
                    <div>
                      {selectedRankOptions.map((option, index) => (
                        <div className="radio" key={index}>
                          <label htmlFor={'selectedRank' + option.value}>
                            <input
                              id={'selectedRank' + option.value}
                              type="radio"
                              name="selectedRank"
                              value={option.value}
                              checked={this.state.selectedRank === option.value}
                              onChange={this.handleSelectedRankChange}
                            />
                            <span>{option.label}</span>
                          </label>
                        </div>
                      ))}
                    </div>
                  </>
                )}
                {signupUrl.length !== 0 && (
                  <>
                    <div className="row">
                      <div className="col-sm-9">
                        <div>
                          <h3>{t('Signup link:')}</h3>
                          <p>
                            {t(
                              'This link leads to the signup form to sign someone up in your downline with the account type settings above. You can copy and paste it to share it via email, text message, social media, or websites.'
                            )}
                          </p>
                          <div className="alert alert-info sign-someone-up-link-wrap">
                            <strong>
                              <a href={signupUrl}>{signupUrl}</a>
                            </strong>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}
